import {EModules} from "@/models";
import {ISop} from "@shared/sop/models";
import {ETechnology} from "@shared/sop/sop-button/models";
import {IPagedList} from "@toolbox/building-blocks/models";
import {EDeviceClasses} from "@toolbox/models";

export enum ETemplateTab {
    Analysis = "analysis",
    Sop = "sop",
}

export enum ESortFields {
    None = "",
    Name = "name",
    Saved = "saved",
}

export interface ITemplateNameId extends ITemplateName {
    id: number;
}

export interface ITemplateName {
    name: string;
}

export interface ITemplateModel extends ITemplateNameId {
    engine?: EModules;
    deviceClass?: EDeviceClasses;
    technology?: ETechnology;
    modified: string;
}

export interface IRegularAndQueueSop extends ISop {
    queue: boolean;
}

export interface ISopListResponse {
    gotAllSop: boolean;
    sops: IRegularAndQueueSop[];
}

export type ITemplateResponse = IPagedList<ITemplateModel>;
